import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, endpoints } from "@/lib/api";
import { PageHeader } from "@/components/ui-blocks/PageHeader";
import { ArrowLeft } from "lucide-react";

export default function ProgramDetailPage() {
  const { slug } = useParams();
  const [programs, setPrograms] = useState([]);
  useEffect(() => { api.get(endpoints.programs).then(setPrograms).catch(() => {}); }, []);
  const p = programs.find((x) => x.slug === slug);
  if (!p) return <main className="container-wide py-24"><p className="text-[hsl(var(--muted-ink))]">Loading program…</p></main>;
  return (
    <main>
      <PageHeader eyebrow="Program" title={p.title} lead={p.summary} />
      <section className="container-wide py-8 lg:py-12">
        <Link to="/programs" className="text-sm text-[hsl(var(--navy))] inline-flex items-center gap-1 mb-6"><ArrowLeft className="h-4 w-4" /> All programs</Link>
        <div className="rounded-2xl overflow-hidden border border-[hsl(var(--border))]"><img src={p.image} alt={p.title} className="w-full h-72 md:h-96 object-cover" /></div>
        <div className="mt-8 prose max-w-3xl text-[hsl(var(--ink))]"><p className="lead">{p.description}</p></div>
      </section>
    </main>
  );
}
